<template src="./Item.html"></template>

<script>
import Arrow from 'svg/arrow-slider.svg';
import Form from 'components/form/Form';
import { mapActions, mapGetters } from 'vuex';
import { endings } from 'src/utils/consts';
import { onWaypoint, isOpenedPopup } from 'src/mixins';
import Parallax from 'vue-parallaxy';

export default {
  mixins: [onWaypoint, isOpenedPopup],

  components: {
    Form,
    Arrow,
    Parallax,
  },

  created() {
    if (!this.portfolio_item.length) {
      this.fetchItem(this.$route.params.id).then(() => {
        this.page = this.portfolio_item;
        this.isShowVeil = false;
      });
    }
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },

  updated() {
    this.updateAnimation();
  },

  watch: {
    // eslint-disable-next-line func-names
    // eslint-disable-next-line
    '$route.params.id': async function() {
      this.isShowVeil = true;
      setTimeout(() => {
        this.fetchItem(this.$route.params.id).then(() => {
          this.page = this.portfolio_item;
          this.isShowVeil = false;
        });
      }, 200);
    },
  },

  data() {
    return {
      page: {},
      isPopupShow: false,
      currentImage: '',
      showAllPhoto: false,
      isShowImage: true,
      windowWidth: window.innerWidth,
      isShowVeil: true,
    };
  },

  computed: {
    ...mapGetters(['portfolio_item']),
    images() {
      if (this.page) {
        // eslint-disable-next-line
        return this.page.photo_set.map((item) => item.image);
      }
      return [];
    },
    headerPhoto() {
      if (this.windowWidth < 768 && this.page.header_photo_mobile) {
        return this.page.header_photo_mobile;
      }
      return this.page.preview_bg;
    },
  },

  methods: {
    ...mapActions(['fetchItem']),
    updateAnimation() {
      this.replaceClass('title-fade');
      this.replaceClass('subtitle-fade');
      this.replaceClass('arrow-fade');
      this.replaceClass('image-fade');
    },
    replaceClass(className) {
      const element = document.querySelector(`.${className}`);
      element.classList.remove(className);
      setTimeout(() => {
        element.classList.add(className);
      }, 1);
    },
    typeTitle(type, id) {
      if (id) {
        return endings[type.substr(0, 2)][id];
      }
      return undefined;
    },

    choosePhoto(item) {
      if (window.innerWidth < 768 && item.image_mobile) {
        return item.image_mobile;
      }
      return item.image;
    },

    photoClass(amount) {
      if (amount === 2) {
        return 'double';
      }
      if (amount === 3) {
        return 'triple';
      }
      if (amount > 5) {
        const left = amount % 4;
        if (left === 2) {
          return 'double';
        }
        if (left === 3) {
          return 'triple';
        }
      }
      return '';
    },

  },
  destroyed() {
    import('jarallax').then(({ jarallax }) => {
      jarallax(document.querySelectorAll('.jarallax'), 'destroy');
    });
  },
};
</script>

<style lang="scss">
.fade-enter, .fade-leave-to{
  opacity: 0;
  transition-duration: 0s;
}
.fade-enter-to, .fade-leave{
  opacity: 1;
  transition-delay: 0.1s;
}
.fade-enter-active,
.fade-leave-active{
  transition: opacity 0.1s ease-out;
}
.page_veil{
  background: white;
  position: fixed;
  z-index: 2000;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100vw;
  height: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/components/portfolio/Item.vue